import React from 'react'
import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';
import { charityData } from '../data/data';
import { Link } from 'react-router-dom';

export default function ClientThree() {

    const settings = {
        container: '.tiny-three-item',
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 8000,
        navPosition: "bottom",
        speed: 1000,
        gutter: 12,
        responsive: {
            520: {
                items: 1
            },
            520: {
                items: 2
            },
            520: {
                items: 3
            },
           
           
        },
      };

  return (
        <div className="tiny-three-item">  
            <TinySlider settings={settings}>
                 {charityData.map((item,index)=>{
              return(
                  <div className="col-lg-4 col-md-6 col-12 mt-4" key={index} style={{padding:20}}>
                      <div className="rounded">
                          <div className="image">
                              <img src={item.image} className="img-fluid" alt="" style={{borderTopLeftRadius:'80px 80px', borderBottomRightRadius:'80px 80px'}} />
                          </div>

                          <div className=" p-4">
                              <Link to="#" className="text-dark title"><h5>{item.title}</h5></Link>
                              <p className="text-muted" style={{textAlign:'justify'}}>{item.desc}</p>

                                                   
                              <div className="mt-3">
                                  <Link to={item.enlace} className="text-primary">Más información<i className="mdi mdi-chevron-right align-middle"></i></Link>
                              </div>
                          </div>
                      </div>
                  </div>
              )
            })}
            </TinySlider>
        </div>
  )
}
